import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

    constructor() { }

    /**
     * Función que retorna el siguiente día programable.
     * @param sunday (OPCIONAL) Cuando es sábado, usa el valor TRUE para programar en lunes (+2), o FALSE en domingo (+1).
     * @returns Devuelve la fecha en formato string yyyy-mm-dd.
     */
    public getNextDay(sunday?: boolean): string {
        const date = new Date();
        if (sunday) {
            return this.parseGMTtoYYYYMMDD(new Date(date.setDate(date.getDate() + 1)));
        } else {
            return this.parseGMTtoYYYYMMDD(new Date(date.setDate(date.getDate() + 2)));
        }
    }

    /**
     * Función para parsear la fecha del componente de calendario, para dotarla de un formato válido para el back.
     * @param date Fecha de tipo Date GMT (Material Datepicker)
     * @returns Devuelve la fecha en formato string yyyy-mm-dd.
     */
    public parseGMTtoYYYYMMDD(date: Date): string {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }

    /**
     * Función para parsear la fecha del componente de calendario, para dotarla de un formato válido para mostrar en frontal.
     * @param date Fecha de tipo Date GMT (Material Datepicker)
     * @returns Devuelve la fecha en formato string dd/mm/yyyy.
     */
    public parseGMTtoDDMMYYYY(date: Date): string {
        return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    }

    /**
     * Función para parsear la fecha proveniente del backend y mostrarla en formato dd/mm/yyyy en las pantallas de front.
     * @param date Fecha de tipo Date UTC (Backend)
     * @returns Devuelve la fecha en formato string dd/mm/yyyy.
     */
    public parseUTCtoDDMMYYYY(date: Date): string {
        return date.getDate() + '/' + (date.getMonth()) + '/' + date.getFullYear();
    }

    /**
     * Función que a partir de una fecha yyyy-mm-dd devuelve dd/mm/yyyy.
     * @param date Fecha string en formato yyyy-mm-dd.
     * @returns Devuelve la fecha en formato string dd/mm/yyyy.
     */
    public parseYYYYMMDDtoDDMMYYYY(date: string): string {
        return date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4);
    }

    /**
     * Función que a partir de una fecha dd/mm/yyyy devuelve yyyy-mm-dd.
     * @param date Fecha string en formato dd/mm/yyyy.
     * @returns Devuelve la fecha en formato string yyyy-mm-dd.
     */
    public parseDDMMYYYYtoYYYYMMDD(date: string): string {
        return date.substr(6, 4) + '-' + date.substr(3, 2) + '-' + date.substr(0, 2);
    }
}
